import {Badge} from '@mantine/core';

import {
    ControlReadiness,
    ControlState,
} from '../types';

/**
 * The live position of a control.
 *
 * UNKNOWN renders as its own neutral state rather than defaulting to ON or OFF —
 * showing a guess as fact on a platform-wide switch is worse than showing nothing.
 */
export const ControlStateBadge = ({state}: { state: ControlState }) => {

    if (state === ControlState.ON) {
        return <Badge color={'teal'} variant={'light'}>On</Badge>;
    }

    if (state === ControlState.OFF) {
        return <Badge color={'red'} variant={'filled'}>Off</Badge>;
    }

    return <Badge color={'gray'} variant={'outline'}>Unknown</Badge>;
};

/**
 * Whether the control can be operated from this screen today. A NOT_WIRED row is
 * shown on purpose — it is the visible reminder of work still owed.
 */
export const ReadinessBadge = ({readiness}: { readiness: ControlReadiness }) => {

    if (readiness === ControlReadiness.OPERATIONAL) {
        return <Badge color={'blue'} variant={'light'}>Operational</Badge>;
    }

    return <Badge color={'yellow'} variant={'light'}>Not yet operational</Badge>;
};
